module.exports = __webpack_public_path__ + "img/yd-gz-img.c7093694.jpg";